import ja from "date-fns/locale/ja";
import React, { useState, useEffect } from "react";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/i18n/datepicker-ja";
import "jquery-ui/themes/base/all.css";
import "../../../../css/jquery.css";
import { Utils } from "utils";
import Modal from "react-modal";

type PROPS = {
  className?: string;
  value?: string;
  onChange?: (value: Date | null) => void;
  disabled?: boolean;
  minDate?: Date;
};

const DateInputForm: React.FC<PROPS> = (props) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [hasSelectedDate, setHasSelectedDate] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  //initialize jquery datepicker
  useEffect(() => {
    ($(".jdatepicker") as any).datepicker({
      dateFormat: "yy/mm/dd",
      changeMonth: true,
      changeYear: true,
      showOtherMonths: true,
      selectOtherMonths: true,
      monthNames: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      dayNames: ["日", "月", "火", "水", "木", "金", "土"],
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      prevText: "prev",
      nextText: "next",
      yearRange: "c-10:c+10",
      onSelect: (dateText: string) => {
        setSelectedDate(dateText as any);
        // Call the handleDateSelect function when the user selects a date
        handleDateSelect();
      },
    });
    return () => {
      ($(".jdatepicker") as any).datepicker("hide");
    };
  }, []);

  const handleDateSelect = () => {
    //set value setHasSelectedDate true
    setHasSelectedDate(true);
  };

  const modalStyle: Modal.Styles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.60)",
      zIndex: 100,
    },
    content: {
      right: "unset",
      bottom: "unset",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      minWidth: "400px",
      maxWidth: "95vw",
      maxHeight: "95vh",
    },
  };

  //check validate Date
  function isValidDate(dateString: any) {
    if (
      typeof dateString !== "string" ||
      !/^\d{4}\/\d{2}\/\d{2}$/.test(dateString)
    ) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split("/");
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);

    // Check if month and day are within valid ranges
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return false;
    }

    // Check if the date object represents a valid date
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) {
      return false;
    }

    // Check if the year, month, and day match the input
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  }

  // Function to handle the event when the user clicks the "OK" button in the modal
  const handleModalOk = () => {
    setIsModalOpen(false); // Đóng modal
    if (inputRef.current) {
      // Set the value of the input field to the current date
      inputRef.current.value = Utils.Date.format3(new Date());
      if (props.onChange) {
        // Call the onChange function with the current date
        props.onChange(Utils.Date.format3(new Date()) as any);
      }
    }
    handleBlur((inputRef as any).current.value);
  };

  // handle the onblur event
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    // get input value
    const inputValue = event.target.value ?? null;
    // value initialization
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    let selectedDate: Date | null = null;
    let formattedDate: string = inputValue;
    // Check if the input value matches the format */*/*
    if (/^\d{1,4}\/\d{1,2}\/\d{1,2}$/.test(inputValue)) {
      // Split the input value by "/" and convert each part to a number
      const [inputYear, inputMonth, inputDay] = inputValue
        .split("/")
        .map((str) => parseInt(str));
      // Validate the parsed date components
      if (
        inputYear >= 1 &&
        inputYear <= currentYear + 2100 &&
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(inputYear, inputMonth, 0).getDate()
      ) {
        // Initialize fullYear as a string or number
        let fullYear: string | number = inputYear.toString();
        // Calculate the current century
        const currentCentury = Math.floor(currentYear / 100) * 100;
        // Adjust the year if it's less than or equal to 3000
        if (inputYear <= 3000) {
          // Adjust the year if it's less than or equal to 99
          if (inputYear <= 99) {
            fullYear = currentCentury + inputYear;
          } else {
            fullYear = inputYear;
          }
          // Format the date string with zero-padded month and day
          formattedDate = `${fullYear}/${inputMonth
            .toString()
            .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
          // Create a Date object from the formatted date string
          selectedDate = new Date(formattedDate);
        } else if (inputYear > 99) {
          // Keep the full year as it is
          fullYear = inputYear.toString();
        }
      }
    }
    // Check if the input value matches the format */*
    if (/^\d{1,2}\/\d{1,2}$/.test(inputValue)) {
      // Split the input value by "/" and convert each part to a number
      const [inputMonth, inputDay] = inputValue
        .split("/")
        .map((str) => parseInt(str));
      // Validate the parsed date components
      if (
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(currentYear, inputMonth, 0).getDate()
      ) {
        // Format the date string with current year and zero-padded month and day
        formattedDate = `${currentYear}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format */*
    if (/^\d{1,2}$/.test(inputValue)) {
      // Parse the input value as a number
      const inputDay = parseInt(inputValue);
      // Validate the parsed day
      if (
        inputDay >= 1 &&
        inputDay <= new Date(currentYear, currentMonth, 0).getDate()
      ) {
        // Format the date string with current year, current month, and zero-padded day
        formattedDate = `${currentYear}/${currentMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format 4 numbers
    if (/^\d{4}$/.test(inputValue)) {
      // Parse the input value for month and day
      const inputMonth = parseInt(inputValue.substring(0, 2));
      const inputDay = parseInt(inputValue.substring(2, 4));
      // Get the current year
      const currentYear = new Date().getFullYear();
      // Validate the parsed month and day
      if (
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(currentYear, inputMonth, 0).getDate()
      ) {
        // Format the date string with current year, input month, and input day
        formattedDate = `${currentYear.toString().padStart(4, "0")}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format 3 numbers
    if (/^\d{3}$/.test(inputValue)) {
      // Parse the input value for month and day
      const inputMonth = parseInt(inputValue.substring(0, 1));
      const inputDay = parseInt(inputValue.substring(1, 3));
      // Get the current year
      const currentYear = new Date().getFullYear();
      // Validate the parsed month and day
      if (
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(currentYear, inputMonth, 0).getDate()
      ) {
        // Format the date string with current year, input month, and input day
        formattedDate = `${currentYear.toString().padStart(4, "0")}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format 5 numbers
    if (/^\d{5}$/.test(inputValue)) {
      // Parse the input value for year, month, and day
      let inputYear: number = parseInt(inputValue.substring(0, 1));
      const inputMonth: number = parseInt(inputValue.substring(1, 3));
      const inputDay: number = parseInt(inputValue.substring(3, 5));
      // if year = 0 get the current year
      if (inputYear === 0) {
        inputYear = new Date().getFullYear();
      }
      // Check the condition and reformat the date
      if (
        inputYear >= 1 &&
        inputYear <= currentYear + 2100 &&
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(inputYear, inputMonth, 0).getDate()
      ) {
        // Adjust fullYear if necessary
        let fullYear: string | number = inputYear;
        if (inputYear < 2100 && inputYear !== new Date().getFullYear()) {
          const currentCentury = Math.floor(currentYear / 100) * 100;
          fullYear = currentCentury + inputYear;
        }
        // Format the date string
        formattedDate = `${fullYear}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format of 6 digits
    if (/^\d{6}$/.test(inputValue)) {
      // Parse the input value for year, month, and day
      let inputYear: number = parseInt(inputValue.substring(0, 2));
      const inputMonth: number = parseInt(inputValue.substring(2, 4));
      const inputDay: number = parseInt(inputValue.substring(4, 6));
      // Validate and adjust the input year
      if (inputYear < 1) {
        inputYear = new Date().getFullYear();
      }
      // Check the condition and reformat the date
      if (
        inputYear >= 1 &&
        inputYear <= currentYear + 2100 &&
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(inputYear, inputMonth, 0).getDate()
      ) {
        // Adjust fullYear if necessary
        let fullYear: string | number = inputYear;
        if (inputYear < 2100 && inputYear !== new Date().getFullYear()) {
          const currentCentury = Math.floor(currentYear / 100) * 100;
          fullYear = currentCentury + inputYear;
        }
        // Format the date string
        formattedDate = `${fullYear}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Check if the input value matches the format of 8 digits
    if (/^\d{8}$/.test(inputValue)) {
      // Parse the input value for year, month, and day
      const inputYear = parseInt(inputValue.substring(0, 4));
      const inputMonth = parseInt(inputValue.substring(4, 6));
      const inputDay = parseInt(inputValue.substring(6, 8));
      // Get the current year
      const currentYear = new Date().getFullYear();
      // Initialize fullYear as inputYear
      let fullYear: string | number = inputYear;
      // Adjust fullYear if inputYear is less than 1
      if (inputYear < 1) {
        fullYear = currentYear;
      }
      // Validate the date components and reformat the date
      if (
        inputYear >= 0 &&
        inputYear <= currentYear + 2100 &&
        inputMonth >= 1 &&
        inputMonth <= 12 &&
        inputDay >= 1 &&
        inputDay <= new Date(inputYear, inputMonth, 0).getDate()
      ) {
        // Adjust fullYear if necessary
        if (inputYear < 2100 && inputYear !== currentYear) {
          const currentCentury = Math.floor(currentYear / 100) * 100;
          if (inputYear <= 99) {
            fullYear = inputYear < 1 ? currentYear : currentCentury + inputYear;
          }
        }
        // Format the date string
        formattedDate = `${fullYear}/${inputMonth
          .toString()
          .padStart(2, "0")}/${inputDay.toString().padStart(2, "0")}`;
        // Create a Date object from the formatted date string
        selectedDate = new Date(formattedDate);
      }
    }
    // Update the value of the input field with the formatted date if inputRef exists
    if (inputRef.current) {
      inputRef.current.value = formattedDate;
    } else {
      (inputRef as any).current.value = inputValue;
    }
    // Call the onChange callback with the selected date if it's not null and onChange callback exists
    if (props.onChange) {
      props.onChange((inputRef as any).current.value);
    }

    if (hasSelectedDate && inputRef.current?.value !== null) {
      // Check for a valid date and display a message if necessary
      if (
        !isValidDate(inputRef.current?.value) &&
        inputRef.current?.value !== null
      ) {
        setErrorMessage("設立年月日の日付が正しくありません。");
        setIsModalOpen(true);
      }
    }
  };

  // Use useEffect to handle updates to props.value
  useEffect(() => {
    // If props.value exists, set the input field value to the parsed date
    if (props.value) {
      const parsedDate = props.value;
      if (inputRef.current) {
        inputRef.current.value = parsedDate;
      }
    } else {
      // If props.value is null or undefined, clear the input field value
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  }, []);

  // Use useEffect to handle updates to selectedDate
  useEffect(() => {
    // If selectedDate is not null and props.onChange exists, call props.onChange with selectedDate
    if (selectedDate !== null && props.onChange) {
      props.onChange(selectedDate);
    }
  }, [selectedDate]);

  // Define a function to handle key down events
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // Call the handleDateSelect function when the user selects a date
    handleDateSelect();
    // Check if the key pressed is "Enter"
    if (event.key === "Enter") {
      // Blur the input field
      if (inputRef.current) {
        inputRef.current.blur();
        // Hide the datepicker if it exists
        ($(".jdatepicker") as any).datepicker("hide");
        // Focus on the next sibling element if it exists
        const nextElement = inputRef.current.nextElementSibling as HTMLElement;
        if (nextElement) {
          nextElement.focus();
        }
      }
    }
  };

  return (
    <div>
      <input
        ref={inputRef}
        type="text"
        className="jdatepicker"
        disabled={props.disabled}
        onBlur={handleBlur}
        onKeyUp={handleKeyDown}
      />
      <Modal isOpen={isModalOpen} style={modalStyle}>
        <div className="flex justify-between items-center gap-4">
          <div className="font-bold text-xl"></div>
          <div className="p-1 rounded cursor-pointer hover:bg-gray-300"></div>
        </div>
        <div className="p-4 flex flex-col gap-4">
          <div className="whitespace-pre-line">{errorMessage}</div>
          <div className="flex justify-center">
            <button className="primary px-4 py-2" onClick={handleModalOk}>
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DateInputForm;
